import styled from "styled-components";
import {
  color_grey_light,
  color_grey_ultra_light,
  color_red_active,
  color_red_default,
  color_red_ultra_light,
  color_white,
} from "../../../constants/colors";

const updatesTextPrimary = "#171717";
const updatesTextSecondary = "#4F4F4F";
const updatesTextMuted = "#747474";

export const UpdatesShell = styled.div`
  width: 100%;
  max-width: 920px;
  min-width: 0;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: ${({ $compact }) => ($compact ? "16px" : "24px")};
  align-items: stretch;

  @media (min-width: 651px) and (max-height: 800px) {
    gap: 10px;
  }
`;

export const UpdatesHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const UpdatesHeading = styled.h1`
  margin: 0;
  font-family: Onest, sans-serif;
  font-size: 32px;
  line-height: 1.15;
  font-weight: 650;
  letter-spacing: -0.6px;
  color: ${updatesTextPrimary};

  @media (max-width: 650px) {
    font-size: 26px;
  }
`;

export const UpdatesSubtitle = styled.p`
  margin: 0;
  font-family: Onest, sans-serif;
  font-size: 15px;
  line-height: 1.45;
  font-weight: 400;
  color: ${updatesTextSecondary};
`;

export const AdminModeBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
`;

export const AdminModeToggle = styled.button`
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid
    ${({ $active }) => ($active ? color_red_ultra_light : color_grey_light)};
  background: ${({ $active }) =>
    $active ? "#fff5f5" : color_white};
  color: ${({ $active }) => ($active ? color_red_active : updatesTextSecondary)};
  font-family: Onest, sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  @media (min-width: 651px) and (max-height: 800px) {
    padding: 5px 12px;
    font-size: 12px;
  }
`;

export const AdminExitButton = styled.button`
  margin-left: auto;
  padding: 8px 14px;
  border: none;
  background: transparent;
  color: ${updatesTextMuted};
  font-family: Onest, sans-serif;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
`;

export const FeedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  position: relative;
  padding-left: ${({ $timeline }) => ($timeline ? "28px" : "0")};

  @media (min-width: 651px) and (max-height: 800px) {
    gap: 6px;
  }

  ${({ $timeline }) =>
    $timeline
      ? `
    &::before {
      content: "";
      position: absolute;
      left: 11px;
      top: 8px;
      bottom: 8px;
      width: 2px;
      background: ${color_grey_light};
      border-radius: 2px;
    }
  `
      : ""}
`;

export const LoadMoreWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding-top: 2px;

  @media (max-width: 650px) {
    flex-direction: column;
    gap: 8px;
    padding-top: 8px;
  }

  @media (max-width: 950px) and (max-height: 500px) {
    flex-direction: column;
    gap: 8px;
    padding-top: 8px;
  }
`;

export const LoadMoreButton = styled.button`
  width: 184px;
  min-height: 44px;
  padding: 10px 20px;
  border-radius: 12px;
  border: 1px solid ${color_red_default};
  background: ${color_red_default};
  color: ${color_white};
  font-family: Onest, sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(240, 79, 79, 0.16);
  transition:
    background-color 0.18s ease,
    border-color 0.18s ease,
    transform 0.18s ease;

  &:hover:not(:disabled) {
    background: ${color_red_active};
    border-color: ${color_red_active};
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  @media (min-width: 651px) and (max-height: 800px) {
    min-height: 40px;
    padding: 8px 16px;
    font-size: 13px;
  }

  @media (max-width: 650px) {
    width: 100%;
  }

  @media (max-width: 950px) and (max-height: 500px) {
    width: 100%;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
    box-shadow: none;
  }
`;

export const EmptyState = styled.div`
  width: 100%;
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${color_white};
  border-radius: 20px;
  border: 1px solid ${color_grey_ultra_light};
  font-family: Onest, sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: ${updatesTextMuted};
`;
